export async function subscribeEmail(email) {
  const backendUrl = process.env.REACT_APP_API_URL || "https://backend-p9wj.onrender.com";
  const response = await fetch(`${backendUrl}/api/subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || "Something went wrong.");
  }

  return data;
}
